import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ChangeAddressService {
  isResidentialAddressUpdated = false;
  isMailingAddressUpdated = false;

  constructor(private http: HttpClient) {}

  updateMailingAddress(policyNumber, email, reqBody) {
    const url = `${environment.backend_server_url_policy}/v2/${email}/${policyNumber}/mailing-address`;
    return this.http.post(url, reqBody);
  }

  updateResidentialAddress(policyNumber, email, form, reqBody) {
    const url = `${environment.backend_server_url_policy}/v2/${email}/${policyNumber}/residential-address?isGaragingLocationSame=${form.isLocationSame}&isMailingAddress=${form.isMailingAddress}`;
    return this.http.post(url, reqBody);
  }

  updateMailingAddressV2(policyNumber, email, reqBody) {
    const url = `${environment.backend_server_url_policy}/v2/${email}/${policyNumber}/mailing-address`;
    return this.http.post(url, reqBody);
  }

  updateResidentialAddressV2(policyNumber, email, form, reqBody) {
    const url = `${environment.backend_server_url_policy}/v2/${email}/${policyNumber}/residential-address?isGaragingLocationSame=${form.isLocationSame}&isMailingAddress=${form.isMailingAddress}`;
    return this.http.post(url, reqBody);
  }

  setIsResidentialAddressUpdated(value) {
    this.isResidentialAddressUpdated = value;
  }

  getIsResidentialAddressUpdated() {
    return this.isResidentialAddressUpdated;
  }

  setIsMailingAddressUpdated(value) {
    this.isMailingAddressUpdated = value;
  }

  getIsMailingAddressUpdated() {
    return this.isMailingAddressUpdated;
  }
}
